// ============================================================
// Who a marker is to THIS viewer, and what it is stroked with
// ============================================================
// COLOUR IS TWO CHANNELS. The body wears the team's livery - the same on
// every client. The ROLE is local (`actorId` and `targetId` are
// per-browser by design) and paints the footprint stroke and a mark.

import { liveryColour, type Livery } from '../../engine/roster/team';

export type TokenRole = 'actor' | 'target' | 'other';

/** The two role strokes; a bystander's stroke is their livery instead. */
export const ROLE_STROKES: Record<Exclude<TokenRole, 'other'>, string> = {
  actor: 'var(--actor)',
  target: 'var(--auspex-red)',
};

/**
 * The fill a body wears: the team's livery token, or the hueless one for a
 * combatant in no team. A CSS variable rather than hex, so the theme owns
 * the colour and an E2E can assert the NAME of it (the healthRamp rule).
 */
export function liveryFill(livery: Livery | null | undefined): string {
  return liveryColour(livery);
}

/** What the footprint, stalk and heading are stroked with. */
export function tokenStroke(role: TokenRole, livery: Livery | null | undefined): string {
  return role === 'other' ? liveryFill(livery) : ROLE_STROKES[role];
}

export function tokenRole(id: string, actorId: string | null, targetId: string | null): TokenRole {
  if (id === actorId) return 'actor';
  if (id === targetId) return 'target';
  return 'other';
}
